import { Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import ListBlog from "./Blogs/ListBlog/ListBlog";
import AddBlog from "./Blogs/AddBlog/AddBlog";
import AddBlogFromZip from "./Blogs/AddBlogFromZip/AddBlogFromZip";
import EditBlog from "./Blogs/EditBlog/EditBlog";
import ListUser from "./Users/ListUser/ListUser";
import AddUser from "./Users/AddUser/AddUser";
import EditUser from "./Users/EditUser/EditUser";
import Sidebar from "../../components/Sidebar";
import api from "../../services/api";
import DashboardMain from "./DashboardMain/DashboardMain";

function Dashboard() {
  const [verifed, setVerified] = useState(false);
  useEffect(() => {
    verify();
  }, []);

  const verify = async () => {
    try {
      const res = await api.post("/auth/verify");
      setVerified(res.data.success);
    } catch (error) {
      if (error.response.status === 401) {
        window.location.href = "/login";
      }
    }
  };
  if (!verifed) {
    return <></>;
  }

  return (
    <div className="flex w-full">
      <div className="fixed h-screen w-64">
        <Sidebar />
      </div>

      <div className="flex-1 ml-64 overflow-x-auto">
        <Routes>
          <Route path="/" element={<DashboardMain />} />
          <Route path="/blogs" element={<ListBlog />} />
          <Route path="/blogs/add" element={<AddBlog />} />
          <Route path="/blogs/add-from-zip" element={<AddBlogFromZip />} />
          <Route path="/blogs/edit/:id" element={<EditBlog />} />

          <Route path="/users" element={<ListUser />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
        </Routes>
      </div>
    </div>
  );
}

export default Dashboard;
